module.exports = "<div class=\"content-i\">\n    <div class=\"content-box\">\n        <div class=\"element-wrapper compact pt-4\">\n            <h6 class=\"element-header\">\n                Profit\n            </h6>\n            <div class=\"element-box-tp\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <img style=\"width: 100%\" src=\"assets/img/section_under_construction.gif\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/index/index.component.html
// module id = ./src/app/index/index.component.html
// module chunks = main